import { useState, useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';

interface AdminNavItem {
  name: string;
  path: string;
  icon: string;
}

const adminPages: AdminNavItem[] = [
  { name: 'Dashboard', path: '/dashboard', icon: 'ri-dashboard-line' },
  { name: 'GHL Setup Guide', path: '/ghl-guide', icon: 'ri-book-open-line' },
  { name: 'GHL Cheat Sheet', path: '/ghl-cheatsheet', icon: 'ri-file-list-line' },
  { name: 'Setup Test', path: '/setup-test', icon: 'ri-checkbox-circle-line' },
  { name: 'Nurture Workflows', path: '/nurture-workflows', icon: 'ri-flow-chart' },
  { name: 'Booking Calendars', path: '/booking-calendars', icon: 'ri-calendar-line' },
  { name: 'AI Employee', path: '/ai-employee', icon: 'ri-robot-line' },
  { name: 'Sitemap Status', path: '/sitemap-status', icon: 'ri-map-pin-line' },
];

export default function AdminNav() {
  const [isOpen, setIsOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const authStatus = sessionStorage.getItem('hli_internal_auth');
    setIsAuthenticated(authStatus === 'hoosier2024');
  }, []);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
      {/* Floating Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 bg-gray-900 text-white rounded-full shadow-lg hover:bg-gray-800 transition-all whitespace-nowrap"
        aria-label="Internal Tools Menu"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className={`${isOpen ? 'ri-close-line' : 'ri-tools-line'} text-lg`}></i>
        </div>
        <span className="text-sm font-medium">Internal Tools</span>
      </button>

      {/* Expanded Menu Panel */}
      {isOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/20 z-40"
            onClick={() => setIsOpen(false)}
          ></div>

          {/* Menu Panel */}
          <div className="fixed bottom-24 right-6 z-50 w-80 bg-white rounded-lg shadow-2xl border border-gray-200 overflow-hidden">
            {/* Header */}
            <div className="px-4 py-3 bg-gray-900 text-white border-b border-gray-700">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-lock-line text-base"></i>
                </div>
                <h3 className="text-sm font-semibold">Password-Protected Pages</h3>
              </div>
            </div>

            {/* Navigation Links */}
            <nav className="py-2">
              {adminPages.map((page) => {
                const isActive = location.pathname === page.path;
                return (
                  <Link
                    key={page.path}
                    to={page.path}
                    onClick={() => setIsOpen(false)}
                    className={`flex items-center gap-3 px-4 py-3 transition-colors ${
                      isActive
                        ? 'bg-orange-50 text-orange-600 border-l-4 border-orange-600'
                        : 'text-gray-700 hover:bg-gray-50 border-l-4 border-transparent'
                    }`}
                  >
                    <div className="w-5 h-5 flex items-center justify-center">
                      <i className={`${page.icon} text-lg`}></i>
                    </div>
                    <span className="text-sm font-medium">{page.name}</span>
                    {isActive && (
                      <div className="ml-auto w-2 h-2 bg-orange-600 rounded-full"></div>
                    )}
                  </Link>
                );
              })}
            </nav>

            {/* Footer */}
            <div className="px-4 py-3 bg-gray-50 border-t border-gray-200">
              <p className="text-xs text-gray-500 text-center">
                {adminPages.length} internal tools available
              </p>
            </div>
          </div>
        </>
      )}
    </>
  );
}